import { Tabs } from 'antd'
import { TabsProps } from 'antd/lib'

import { useLocales } from 'src/locales'

import { OrganizationalTree, OrganizationalOrganogram } from '..'

import { useStyles } from './styles'

export const OrganizationalTabs = () => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const tabItems: TabsProps['items'] = [
    {
      key: 'tree',
      label: t('organizational_structure.tree'),
      children: <OrganizationalTree />
    },
    {
      key: 'organogram',
      label: t('organizational_structure.organioram'),
      children: <OrganizationalOrganogram />
    }
  ]

  return <Tabs defaultActiveKey="1" items={tabItems} className={styles.tabs} />
}
